export default __webpack_public_path__ + "static/media/4.bb7dab39.jpg";